import { Box, Button, Container, Typography } from '@mui/material'
import React from 'react'
import arrow from '../../assets/images/website/launcharrow.png'
import heroimage from '../../assets/images/website/hero_image.png'
import cacao from '../../assets/images/website/kakao.png'
import nut from '../../assets/images/website/nut.png'
import usdt from '../../assets/images/website/usdt.png'
import charget from '../../assets/images/website/charget.png'
import { Link, useNavigate } from "react-router-dom";
function HeroSection() {
  const navigate = useNavigate()

  
  return (
    <React.Fragment>
      <Box className='website_hero'>
        <Container maxWidth='xl'>
          <Box sx={{ padding: { xs: '66px 0px 80px', lg: '80px 0px 140px' }, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexDirection: { xs: 'column', lg: 'row' } }}>
            <Box sx={{ width: { xs: '100%', lg: '50%', xl: '40%' } }}>
              <Typography sx={{ color: '#fff', fontWeight: 700, fontFamily: '"Inter", sans-serif', fontSize: { xs: 36, lg: 54 }, lineHeight: { xs: '44px', lg: '65px' }, textAlign: { xs: 'center', lg: 'start' } }}>
              Yatırımın Gücünü Keşfet, Kriptoya Güvenle Adım At!
              </Typography>
              <Typography sx={{ textAlign: { xs: 'center', lg: 'start' }, color: '#fff', fontWeight: 400, fontFamily: '"Inter", sans-serif', fontSize: { xs: 18, lg: 22 }, padding: { xs: '24px 0px 40px', lg: '24px 0px 60px' } }}>
              
              Povego ile güvenli bir biçimde, kripto varlıklara yatırım yapma imkanına kavuşun. Blokzincirin güvenliği ile rahatça alım satım yapın.
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: { xs: 'center', lg: 'start' } }}>
                
              </Box>
            </Box>
            <Box sx={{ width: { xs: '95%', sm: '50% ', xl: '50%' }, justifyContent: { xs: 'center', lg: 'center' } }}>
              
            </Box>
          </Box>
        </Container>
      </Box>
    </React.Fragment>
  )
}

export default HeroSection
